import { AutoPayment } from "../../../api/autoPayment.types";
import { AutoPaymentsMainAction } from "./autoPayments.main.types";

export const autoPaymentsMainRequestAction = (): AutoPaymentsMainAction => ({ type: 'AUTO_PAYMENT_MAIN_REQUEST' })

export const autoPaymentsMainSuccessAction = (auto_payments: AutoPayment[]): AutoPaymentsMainAction => ({ type: 'AUTO_PAYMENT_MAIN_SUCCESS', params: auto_payments })

export const autoPaymentsMainFailureAction = (error?: any): AutoPaymentsMainAction => ({ type: 'AUTO_PAYMENT_MAIN_FAILURE', params: error })